<template>
  <modal
    name="error"
    :click-to-close="false"
    height="auto"
    :adaptive="true"
    :scrollable="true"
    :pivot-y="0.2"
    class="error-modal"
    @before-open="beforeOpen"
  >
    <Button
      v-if="showCloseButton"
      class="close-button"
      @click="$modal.hide('error')"
    >
      <v-icon slot="icon-end" name="times" />
    </Button>

    <Error
      :errors="errors"
      class="error"
      :error-action="errorAction"
      :error-action-label="errorActionLabel"
    />

    <slot />

    <ModalFooter />
  </modal>
</template>

<script>
import Error from "@/components/UI/Error";
import ModalFooter from "@/components/UI/ModalFooter";

export default {
  name: "ErrorModal",
  components: { Error, ModalFooter },
  data() {
    return {
      errors: [],
      showCloseButton: true,
      errorAction: null,
      errorActionLabel: "",
    };
  },
  methods: {
    beforeOpen(e) {
      if (this.$has(e, "params.showCloseButton"))
        this.showCloseButton = e.params.showCloseButton;

      if (this.$has(e, "params.errors")) this.errors = e.params.errors;

      if (this.$has(e, "params.errorAction"))
        this.errorAction = e.params.errorAction;

      if (this.$has(e, "params.errorActionLabel"))
        this.errorActionLabel = e.params.errorActionLabel;
    },
  },
  render() {
    return true;
  },
};
</script>

<style scoped>
.error {
  @apply bg-transparent border-0 shadow-none p-0;
}

.error-modal {
  @apply mx-2;

  @screen sm {
    @apply mx-auto;
  }
}
</style>
